import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Pagination } from '../../../../common/pagination'
import { Table } from '../../../../common/table'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { deleteTypes, tableSchema } from '../constant'
import Action from './Action'
import CheckboxAll from './CheckboxAll'
import CheckboxItem from './CheckboxItem'
import { DEFAULT_PAGE } from './constant'
import classes from './index.module.scss'
import Name from './Name'
import {
  changeDeleteType,
  changePage,
  changePageSize,
  selectById,
  selectCell,
  selectChecked,
  selectDeleteType,
  selectFiinGateTemplateId,
  selectIds,
  selectPage,
  selectPageSize,
  uncheckAllItem,
} from './store/slice'

const TableTemplate = ({
  typeTemplate,
  callApiTemplates,
  loading,
  total,
  nameKey,
  deleteTemplate,
  openTemplate,
  setDefaultTemplate,
  idKey,
  updateTemplate,
  callApiDefaultTemplate,
  defaultTemplate,
}) => {
  const dispatch = useDispatch()

  const ids = useSelector(selectIds)
  const locale = useSelector((state) => state.i18n.locale)
  const byId = useSelector(selectById)
  const checked = useSelector(selectChecked)
  const page = useSelector(selectPage)
  const pageSize = useSelector(selectPageSize)
  const deleteType = useSelector(selectDeleteType)
  const fiinGateTemplateId = useSelector(selectFiinGateTemplateId)

  useEffect(() => {
    setPage(DEFAULT_PAGE)
    dispatch(uncheckAllItem())
    dispatch(changeDeleteType(deleteTypes.IN))
  }, [typeTemplate])

  useEffect(() => {
    if (!ids.length && page !== DEFAULT_PAGE) {
      setPage(Math.max(Math.ceil(total / pageSize), DEFAULT_PAGE))
    }
  }, [ids])

  useEffect(() => {
    if (typeTemplate) {
      callApiTemplates({
        Page: page,
        PageSize: pageSize,
        TemplateType: typeTemplate,
      })
    }
  }, [typeTemplate, page, pageSize])

  useEffect(() => {
    if (typeTemplate) {
      callApiDefaultTemplate({
        TemplateType: typeTemplate,
      })
    }
  }, [typeTemplate])

  const setPage = (page) => dispatch(changePage(page))

  const setPageSize = (pageSize) => dispatch(changePageSize(pageSize))

  const isSelectNotIn = deleteType === deleteTypes.NOTIN

  const checkedWithoutFiinGateTemplate = fiinGateTemplateId
    ? { ...checked, [fiinGateTemplateId]: isSelectNotIn }
    : checked

  return (
    <Table
      ids={ids}
      columnDraggable={false}
      getDataFromRedux={selectCell}
      isLoading={loading}
      rowDraggable={false}
      hasFooter={false}
      resizable={false}
      selectedRowId={checkedWithoutFiinGateTemplate}
      isSelectNotIn={isSelectNotIn}
      renderPagination={() => (
        <div className={classes.mt12}>
          <Pagination {...{ page, setPage, pageSize, setPageSize, total }} />
        </div>
      )}
      schema={Object.keys(tableSchema).map((key) => {
        const title = `preferenceSetting.${key}`
        const colId =
          tableSchema[key] === tableSchema.NAME ? nameKey : tableSchema[key]
        const result = {
          colId,
          title,
          disableSort: true,
          tdStyle: colId === nameKey ? { padding: 0 } : undefined,
        }

        return {
          ...result,
          isI18n: true,
          render: [tableSchema.CREATE_AT, tableSchema.MODIFIED_AT].includes(
            colId,
          )
            ? (val) => formatDateTime(val, FORMAT.DATE, locale)
            : colId === nameKey
            ? (val, { rowId }) => (
                <Name
                  value={val}
                  rowId={rowId}
                  updateTemplate={updateTemplate}
                  nameKey={nameKey}
                  typeTemplate={typeTemplate}
                  page={page}
                  pageSize={pageSize}
                />
              )
            : colId === tableSchema.CHECKBOX
            ? (_, { rowId }) => {
                const isDefault = byId[rowId].isDefault
                const isFiinGateTemplate = byId[rowId].isFiinGateTemplate

                return (
                  !isDefault &&
                  !isFiinGateTemplate && <CheckboxItem rowId={rowId} />
                )
              }
            : colId === tableSchema.ACTION
            ? (_, { rowId }) => (
                <Action
                  rowId={rowId}
                  deleteTemplate={deleteTemplate}
                  openTemplate={openTemplate}
                  setDefaultTemplate={setDefaultTemplate}
                  nameKey={nameKey}
                  typeTemplate={typeTemplate}
                  idKey={idKey}
                  page={page}
                  pageSize={pageSize}
                  defaultTemplate={defaultTemplate}
                />
              )
            : undefined,
          renderTh:
            colId === tableSchema.CHECKBOX
              ? () => (
                  <CheckboxAll
                    defaultTemplate={defaultTemplate}
                    idKey={idKey}
                  />
                )
              : undefined,
        }
      })}
    />
  )
}

export default TableTemplate
